import { ClientApi } from "@/api/ClientApi";
import { CurrencyApi } from "@/api/CurrencyApi";
import { CUSTOM_ELEMENT, EDITOR_INPUT, PHONE_INPUT_TYPE, RADIO_INPUT_TYPE, SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { INVOICE_CREDIT_TYPE_CODE, INVOICE_HOLDING_TYPE_CODE, INVOICE_TYPES, SETTLEMENT_TYPES, TIPOS_DE_IDENTIFICACION } from "@utils/Constants";
import { generateCurrencyOptionLabel } from "@utils/Currency";
import { CurrencyIdPubSub, OpenAddClientPubSub } from "@utils/pubsubs/PubSub";
import { Button } from "reactstrap";

const CreditNoteFormConfig = {
    sections: [
        {
            "fields": [
                [
                    {
                        "type": "text",
                        "name": "fecha",
                        "label": "Fecha",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                    },
                    {
                        "type": RADIO_INPUT_TYPE,
                        "name": "tipo",
                        "validation": Yup.string().required(),
                        "label": "Tipo Factura",
                        "isHorizontalValues": true,
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 3,
                                "offset": 1
                            }
                        },
                        "options": INVOICE_TYPES,
                        "defaultValue": 0,
                    },
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "currencyId",
                        "label": "Moneda",
                        "optionsFunction": () => CurrencyApi.optionsList({}, (i) => generateCurrencyOptionLabel(i)),
                        "onChangePubSub": (value: string) => CurrencyIdPubSub.publish({ currencyId: value }),
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": "number",
                        "isDecimal": true,
                        "name": "exchange_rate",
                        "min": "0",
                        "step": "0.01",
                        "label": "Tipo de Cambio",
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3,
                            "xl": 2,
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ]
            ]
        },
        {
            title: "Datos de Cliente",
            "fields": [
                [
                    {
                        "type": "text",
                        "name": "client_code",
                        "exludeFromSubmit": true,
                        "label": "Cod",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 2
                            }
                        }
                    },
                    {
                        "type": "text",
                        "name": "identificacion",
                        "label": "Identification",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 2
                            }
                        }
                    },
                    {
                        "type": "text",
                        "name": "nombre_factura",
                        "label": "Nombre Facturacion",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 8
                            }
                        }
                    },
                ]
            ]
        }
    ],
    additionalSections: [
        {
            "fields": [
                [
                    {
                        "type": "money",
                        "isDecimal": true,
                        "step": "0.01",
                        "name": "montoNota",
                        "isHorizontal": true,
                        "visibilityHiddenIf": () => true, // by default this input is hidden, only visible for credit note by price
                        "min": "1",
                        "label": "Valor de Nota",
                        "labelSizing": {
                            "sm": 2,
                        },
                        "sizing": {
                            "sm": 4,
                            "md": 3,
                            "lg": 2,
                        },
                        "validation": Yup.number().typeError("El valor debe ser un número válido")
                            .required("Este campo es requerido"),
                    },
                ],
                [
                    {
                        "type": EDITOR_INPUT,
                        "name": "description",
                        "label": "Razon / Motivo Devolucion",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 8
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ]
            ]
        }
    ]
};


export default CreditNoteFormConfig;